import { useI18n } from 'vue-i18n'
import type { SideBarList } from '../types/model/sidebar'

export default function useSideBar() {
  const { t } = useI18n()
  const sideBarList: SideBarList = [
    {
      title: t('branch.branches'),
      icon: 'buildingOffice',
      value: 'branch',
      link: '/branch',
    },
    {
      title: t('personnel.personnels'),
      icon: 'users',
      value: 'personnel',
      link: '/personnel',
    },
    {
      title: t('lawyer.lawyers'),
      icon: 'scales',
      value: 'lawyer',
      link: '/lawyer',
    },
    {
      title: t('helpRecipient.helpRecipients'),
      icon: 'userCircle',
      value: 'helpRecipient',
      link: '/helpRecipient',
    },
    {
      title: t('financialContract'),
      icon: 'coins',
      value: 'contract',
      link: '/contract/financial',
      children: [
        {
          title: t('financial.financial'),
          icon: 'dot',
          value: 'financial',
          link: '/contract/financial',
        },
        {
          title: t('buy.buy'),
          icon: 'dot',
          value: 'buy',
          link: '/contract/financial/buy',
        },
        {
          title: t('sale.sale'),
          icon: 'dot',
          value: 'sale',
          link: '/contract/financial/sale',
        },
        {
          title: t('mortgageEstate.mortgage'),
          icon: 'dot',
          value: 'mortgageFinancial',
          link: '/contract/financial/mortgage',
        },
        {
          title: t('rentEstate.rent'),
          icon: 'dot',
          value: 'rent',
          link: '/contract/financial/rent',
        },
        {
          title: t('financialEndowment.endowment'),
          icon: 'dot',
          value: 'endowment',
          link: '/contract/financial/endowment',
        },
        {
          title: t('donation.donation'),
          icon: 'dot',
          value: 'donation',
          link: '/contract/financial/donation',
        },
        {
          title: t('peace.peace'),
          icon: 'dot',
          value: 'peace',
          link: '/contract/financial/peace',
        },
        {
          title: t('exchange.exchange'),
          icon: 'dot',
          value: 'exchange',
          link: '/contract/financial/exchange',
        },
        {
          title: t('mudaraba.mudaraba'),
          icon: 'dot',
          value: 'mudaraba',
          link: '/contract/financial/mudaraba',
        },
      ],
    },
    {
      title: t('nonFinancialContract'),
      icon: 'handShake',
      value: 'nonFinancial',
      link: '/contract/nonFinancial/voluntary',
      children: [
        {
          title: t('voluntary.voluntary'),
          icon: 'dot',
          value: 'voluntary',
          link: '/contract/nonFinancial/voluntary',
        },
        {
          title: t('support.support'),
          icon: 'dot',
          value: 'support',
          link: '/contract/nonFinancial/support',
        },
        {
          title: t('recipient.recipient'),
          icon: 'dot',
          value: 'recipient',
          link: '/contract/nonFinancial/recipient',
        },
      ],
    },
    {
      title: t('estateContracts'),
      icon: 'houseLine',
      value: 'estateContract',
      link: '/contract/estate/buy',
      children: [
        {
          title: t('buyEstate.buy'),
          icon: 'dot',
          value: 'buyEstate',
          link: '/contract/estate/buy',
        },
        {
          title: t('saleEstate.sale'),
          icon: 'dot',
          value: 'saleEstate',
          link: '/contract/estate/sale',
        },
        {
          title: t('mortgageEstate.mortgage'),
          icon: 'dot',
          value: 'mortgageEstate',
          link: '/contract/estate/mortgage',
        },
        {
          title: t('rentEstate.rent'),
          icon: 'dot',
          value: 'rentEstate',
          link: '/contract/estate/rent',
        },
        {
          title: t('endowmentEstate.endowment'),
          icon: 'dot',
          value: 'endowmentEstate',
          link: '/contract/estate/endowment',
        },
        {
          title: t('donationEstate.donation'),
          icon: 'dot',
          value: 'donationEstate',
          link: '/contract/estate/donation',
        },
        {
          title: t('peaceEstate.peace'),
          icon: 'dot',
          value: 'peaceEstate',
          link: '/contract/estate/peace',
        },
        {
          title: t('exchangeEstate.exchange'),
          icon: 'dot',
          value: 'estateExchangeEstate',
          link: '/contract/estate/exchange',
        },
        {
          title: t('muzarahEstate.muzarah'),
          icon: 'dot',
          value: 'muzarahEstate',
          link: '/contract/estate/muzarah',
        },
      ],
    },
    {
      title: t('words.registration'),
      icon: 'notePencil',
      value: 'registration',
      link: '/registration/notice',
      children: [
        {
          title: t('notice.judicialNotice'),
          icon: 'dot',
          value: 'notice',
          link: '/registration/notice',
        },
        {
          title: t('judicialRuling.judicialRuling'),
          icon: 'dot',
          value: 'judicialRuling',
          link: '/registration/judicialRuling',
        },
        {
          title: t('billRequest.RequestForABillAndDefense'),
          icon: 'dot',
          value: 'billRequest',
          link: '/registration/bill-request',
        },
        {
          title: t('lawyerRequest.lawyerRequest'),
          icon: 'dot',
          value: 'lawyerRequest',
          link: '/registration/lawyerRequest',
        },
        {
          title: t('communicationLines.RequestForCommunicationLines'),
          icon: 'dot',
          value: 'communicationLines',
          link: '/registration/communications',
        },
        {
          title: t('prisoners.prisonerDonations'),
          icon: 'dot',
          value: 'prisonerDonations',
          link: '/registration/prisoners',
        },
      ],
    },

    {
      title: t('words.claim'),
      icon: 'gavel',
      value: 'claim',
      link: '/claim/financialClaim',
      children: [
        {
          title: t('financialClaim.financial'),
          icon: 'dot',
          value: 'financialClaim',
          link: '/claim/financialClaim',
        },
        {
          title: t('banking.banking'),
          icon: 'dot',
          value: 'banking',
          link: '/claim/banking',
        },
        {
          title: t('property.property'),
          icon: 'dot',
          value: 'property',
          link: '/claim/property',
        },
        // {
        //   title: t('commercial.commercial'),
        //   icon: 'dot',
        //   value: 'commercial',
        //   link: '/claim/commercial',
        // },
        {
          title: t('criminal.criminal'),
          icon: 'dot',
          value: 'criminal',
          link: '/claim/criminal',
        },
        {
          title: t('fraud.fraud'),
          icon: 'dot',
          value: 'fraud',
          link: '/claim/fraud',
        },
        {
          title: t('breachOfTrust.breachOfTrust'),
          icon: 'dot',
          value: 'breachOfTrust',
          link: '/claim/breachOfTrust',
        },
        // {
        //   title: t('personnelEmbezzlement.personnelEmbezzlement'),
        //   icon: 'dot',
        //   value: 'personnelEmbezzlement',
        //   link: '/claim/personnelEmbezzlement',
        // },
        {
          title: t('propertyTheft.propertyTheft'),
          icon: 'dot',
          value: 'propertyTheft',
          link: '/claim/propertyTheft',
        },
        {
          title: t('cybercrime.cybercrime'),
          icon: 'dot',
          value: 'cybercrime',
          link: '/claim/cybercrime',
        },
        {
          title: t('missing.missing'),
          icon: 'dot',
          value: 'missing',
          link: '/claim/missing',
        },
        {
          title: t('personnelDispute.personnelDispute'),
          icon: 'dot',
          value: 'personnelDispute',
          link: '/claim/personnelDispute',
        },
        {
          title: t('accident.accident'),
          icon: 'dot',
          value: 'accident',
          link: '/claim/accident',
        },
        {
          title: t('publicComplaint.publicComplaint'),
          icon: 'dot',
          value: 'publicComplaint',
          link: '/claim/publicComplaint',
        },
        {
          title: t('socialSecurity.socialSecurity'),
          icon: 'dot',
          value: 'socialSecurity',
          link: '/claim/socialSecurity',
        },
        {
          title: t('courtOfJustice.courtOfJustice'),
          icon: 'dot',
          value: 'courtOfJustice',
          link: '/claim/court-of-justice',
        },
      ],
    },
  ]

  return {
    sideBarList,
  }
}
